<template>
    <div class='time__container'>
        <div class='input__container'>
            <input type='number' placeholder='00' size='2' max="12" min="0" @keydown="validateNumber" v-model='hours' />
            <p>:</p>
            <input type='number' placeholder='00' size='2' max="59" min="0" @keydown="validateNumber" v-model='minutes' />
        </div>
        <div class='type__holder'>
            <p @click="changeType('AM')" :class="{'active__type': active === 'AM'}">AM</p>
            <p @click="changeType('PM')" :class="{'active__type': active === 'PM'}">PM</p>
        </div>
    </div>
</template>

<script>
export default {
    data () {
        return {
            active: 'AM',
            hours: null,
            minutes: null
        }
    },
    methods: {
        changeType (type) {
            this.active = type
            if(parseInt(this.hours) === 12 && this.active === 'PM'){
                this.hours = '00'
            }
            this.timeChanged()
        },
        timeChanged () {
            let time = 0
            let hours = parseInt(this.hours)

            if(this.active === 'PM'){
                if(hours === 12){
                    hours = '00'
                } else {
                    hours = hours + 12
                }
            } else if(hours < 10) {
                hours = '0' + hours
            }

            if(this.minutes === null){
                this.minutes = '00'
            }

            time = hours + ':' + this.minutes + ':00'

            this.$emit('onChange', time)
        },
        validateNumber (e) {
            var invalidChars = ["-", "+", "e"]
            if(invalidChars.includes(e.key)){
                e.preventDefault()
            }
        }
    },
    props: {
        value: {
            type: String,
            default: ''
        }
    },
    watch: {
        value: function (val) {
            let time = val.split(":")
            let hours = parseInt(time[0])
            this.minutes = time[1]
            
            if(hours > 12) {
                this.hours = hours
                this.active = "PM"
            } else {
                this.hours = hours
                this.active = "AM"
            }
        },
        hours: function(val){
            if(parseInt(this.hours) === 12 && this.active === 'PM'){
                this.hours = '00'
            }

            if (parseInt(val) > 12) {
                this.hours = 12
            }

            this.timeChanged()
        },
        minutes: function (val) {
            if(parseInt(val) > 59) {
                this.minutes = 59
            }

            this.timeChanged()
        }
    }
}
</script>

<style scoped>
.time__container{
    border: 1px solid #CCD4E0;
    border-radius: 5px;
    box-shadow: 0px 0px 6px rgba(81, 95, 152, 0.161);
    height: 35px;
    box-sizing: border-box;
    padding-left: 10px;
    /* width: 100%; */
    margin-top: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-right: 10px;
}

.input__container{
    display: flex;
    margin-top: 0 !important;
}

.input__container p{
    margin: 0;
    padding: 0;
    color: #777777;
    font-size: 14px;
}

input{
    border: none;
    color: #777777;
    font-size: 14px;
    max-width: 20px;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

input:focus{
    outline:none;
}

.type__holder{
    display: flex;
    align-items: center;
}

.type__holder p{
    display: inline-block;
    color: #B5B5B5;
    font-size: 14px;
    margin: 0;
    padding: 0;
    cursor: pointer;
}

.type__holder p:first-of-type{
    margin-right: 5px;
}

.active__type {
    color: #777777 !important;
}
</style>
